'use client'
import { useState } from 'react'
import { Provider } from 'react-redux'
import type { ReactNode } from 'react'

import { makeStore } from '@/integrations/redux/store'
import type { AppStore } from '@/integrations/redux/store'


export default function ReduxStoreProvider({
  children,
}: {
  children: ReactNode
}) {
  const [store] = useState<AppStore>(() => makeStore())

  return <Provider store={store}>{children}</Provider>
}